import Vue from 'vue'
import Form from './lib/Form.js'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'
import App from './components/App'
import AppNoHeaderFooter from './components/AppNoHeaderFooter'
import router from './router'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
require('./bootstrap');
import InputTag from 'vue-input-tag';
import VueSocialSharing from 'vue-social-sharing'
import VueMask from 'v-mask'
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

Vue.component('calendar', Calendar)
Vue.component('date-picker', DatePicker)
Vue.component('headersite', require('./components/mainsite/partial/Header.vue')
	.default); //==== PARTIAL
Vue.component('subheader', require(
	'./components/mainsite/partial/SubHeader.vue').default); //==== PARTIAL
Vue.component('footersite', require('./components/mainsite/partial/Footer.vue')
	.default); //==== PARTIAL
Vue.component('verticalnavbar', require(
	'./components/widget/VerticalNavbar.vue').default); //==== PARTIAL
Vue.component('input-tag', InputTag);
Vue.use(VueSocialSharing);
Vue.use(VueMask);

window.Form = Form;
window.axios = axios;

new Vue({
	router,
	computed: {
    DynamicComponent() {
      // Daftar path yang akan menggunakan App2
      const specialRoutes = ['/community/teaser/nongkrong-bareng-barry','/community/touring/jalur-tawa'];

      // Cek apakah URL path diawali dengan salah satu dari specialRoutes
      return specialRoutes.some(route => this.$route.path.startsWith(route)) ? AppNoHeaderFooter : App;
    }
  },
	render: function (h) {
    return h(this.$options.computed.DynamicComponent.call(this));
  }
}).$mount('#app')
